module.exports = __webpack_public_path__ + "img/AutoSendToApproval.78ec88f1.svg";